export const CURRENCY_SYMBOL = '$';

export const INPUT_STYLE = {
  paddingLeft: 'space-600',
} as const;
